module.exports = __webpack_public_path__ + "img/color-wand-outline.3d547c65.svg";